import { Pipe, PipeTransform } from '@angular/core';
import { OrganisationDto } from '@careapp-group/ng-sdk';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { distinct, map } from 'rxjs/operators';
import { ORGANISATIONS, getEntities } from '../../store';

@Pipe({
    name: 'organisationFromId',
    pure: true,
    standalone: false
})
export class OrganisationFromIdPipe implements PipeTransform {
  constructor(private store: Store<any>) {}
  public transform(id: string): Observable<OrganisationDto> {
    if (!id || typeof id != 'string') {
      return null;
    }
    return this.store.select(getEntities(ORGANISATIONS)).pipe(
      map(
        (organisationEntities: { [key: string]: OrganisationDto }) =>
          organisationEntities[id] ?? null
      ),
      distinct()
    );
  }
}
